<template>
<div class="container">
  <div class="handle-box">
    <el-input v-model="query.user_name" placeholder="用户名" class="handle-input mr10 w150"></el-input>
    <el-input v-model="query.phone" placeholder="用户手机号" class="handle-input mr10 w150"></el-input>
    <el-input v-model="query.coupon_name" placeholder="优惠券名" class="handle-input mr10 w150"></el-input>
    <el-input v-model="query.store_coupon_id" placeholder="优惠券ID" class="handle-input mr10 w150"></el-input>
    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
  </div>
  <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
      :cell-style="centerStyle"
  >
    <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
    <el-table-column prop="coupon_name" label="优惠券名称" align="center"></el-table-column>
    <el-table-column prop="store_coupon_id" label="优惠券ID" align="center"></el-table-column>
    <el-table-column prop="status" label="状态" align="center">
      <template #default="scope">
        {{scope.row.status===2 ? '已使用' : '未使用'}}
      </template>
    </el-table-column>
    <el-table-column prop="user_name" label="用户名" align="center"></el-table-column>
    <el-table-column prop="phone" label="用户手机号" align="center"></el-table-column>
    <el-table-column prop="uid" label="用户ID" align="center"></el-table-column>
  </el-table>
  <div class="pagination">
    <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="query.page"
        :page-size="query.page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
    ></el-pagination>
  </div>
</div>
</template>
<script>
import {getCouponRecord} from "@/api/coupon"
export default {
  name:"CouponUser",
  data(){
    return{
      query:{
        page:1,
        page_size:10,
      user_name:'',
      coupon_name:'',
      store_coupon_id:null,
        phone:''
      },
      pageTotal:null,
      tableData:[],
      roleMap:new Map()
    }
  },
  created() {
    this.getData()
  },
  methods:{
    centerStyle(){
      return 'text-align:center'
    },
    getData(){
      getCouponRecord(this.query).then(res=>{
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
  handleSearch(){
    this.query.page = 1
    this.getData()
  }
  }
}
</script>
<style scoped>
.handle-input{
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.el-select{
  margin-right: 10px;
}
.el-button{
  margin-right: 10px;
  margin-bottom: 10px;
}
.handle-box {
  margin-bottom: 10px;
}
.el-form .el-input{
  width: 40%;
}
.red{
  color: red;
}
.w150{
  width: 150px;
}
.w160{
  width: 160px;
}
</style>